import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch6_p03 } from "../../../layouts/ch6_p03/ch6_p03";

export class Chapter6Page3 extends AbstractStoryState implements ReturnType<typeof ch6_p03> {

    readonly bg = this.addChild(new SceneSprite());
    readonly horse = this.addChild(new SceneSprite());
    readonly holly = this.addChild(new SceneSprite());
    readonly tyler = this.addChild(new SceneSprite());
    readonly rain = [this.addChild(SceneSprite.withPrefix("ch6_p03/")), this.addChild(SceneSprite.withPrefix("ch6_p03/"))];

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch6_p03/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch6_p03/"));
    readonly linesLeft = this.addChild(SceneSprite.withPrefix("ch6_p03/"));
    readonly linesRight = this.addChild(SceneSprite.withPrefix("ch6_p03/"));

    dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch6_p03.call(this);

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
        TweenLite.delayedCall(1.5, () => {
            this.gotoNextState({ transition: "left" });
        });
    }
}